<style lang="less" scoped>
.class-info {
  font-size: 18px;
  .contentTitle {
    height: 50px;
    line-height: 50px;
    border-bottom: 1px solid #edeef1;
    padding: 0 30px;
    color: #000000;
    font-size: 16px;
    font-weight: 600;
  }
  .mess-info {
    margin: 0px 30px 0 30px;
    .title {
      font-size: 14px;
      color: #867d7b;
      margin-top: 20px;
    }
  }
  .content {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 10px;
    padding: 20px 0;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    .edit {
      color: @primary-color;
      cursor: pointer;
    }
    .tip {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #867d7b;
      line-height: 22px;
    }
    .tip-code {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #867d7b;
      line-height: 22px;
      margin-top: 100px;
    }
  }
  .js {
    width: 100px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #db5647;
    line-height: 24px;
    margin-top: 15px;
    padding-left: 30px;
    cursor: pointer;
  }
  .disabled {
    color: #867d7b !important;
    cursor: not-allowed !important;
  }
}
.edit-name {
  display: flex;
  .new-name {
    line-height: 30px;
  }
}
.del-name {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #040506;
  line-height: 24px;
  text-align: center;
  color: #db5647;
}
/deep/.ant-modal-footer {
  text-align: center;
  border-top: none;
}
</style>
<template>
  <div class="class-info">
    <div class="contentTitle">班级设置</div>
    <div class="mess-info">
      <div class="title">班级名</div>
      <div class="content">
        <span>{{ classInfo.className }}</span>
        <span
          :class="{ edit: true, disabled: classInfo.isDel }"
          @click="editFun"
          >修改</span
        >
      </div>
      <div class="title">班级ID</div>
      <div class="content">
        <span>{{ classInfo.classNum }}</span>
        <span class="tip">网页端学生搜索班级ID加入班级</span>
      </div>
      <div class="title">班级二维码</div>
      <div class="content">
        <span ref="qrcode"></span>
        <div class="tip-code">手机端或Pad端可通过扫描二维码加入班级</div>
      </div>
    </div>
    <div :class="{ js: true, disabled: classInfo.isDel }" @click="jsFun">
      解散班级
    </div>
    <a-modal
      title="修改"
      width="460px"
      :visible="editVis"
      @cancel="editCancel"
      footer=""
    >
      <template>
        <div class="edit-name">
          <div class="new-name">新的班级名称：</div>
          <a-input
            v-model="newName"
            placeholder="请输入新的班级名称"
            style="width: 240px; margin-left: 20px"
          ></a-input>
        </div>
        <div class="f-del">
          <div class="f-c" @click="editCancel">取消</div>
          <div class="f-s" @click="editOk">确认</div>
        </div>
      </template>
    </a-modal>
    <a-modal
      title="解散班级警告"
      width="460px"
      :visible="jsVis"
      @cancel="jsCancel"
      footer=""
    >
      <template>
        <div class="del-name"> 解散班级后，老师和班级成员将被移除班级，<br /> 你确认要解散班级吗？</div>
      </template>
      <div class="f-del">
        <div class="f-c" @click="jsCancel">取消</div>
        <div class="f-s" @click="jsOk">确认</div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import requestUrl from '../../../utils/requestUrl.js'
import Bus from '@/utils/bus.js'
export default {
  name: 'ClassInfo',
  data () {
    return {
      requestUrl,
      classInfo: {},
      qrcode: null,
      editVis: false,
      jsVis: false,
      access_token: this.$store.state.access_token,
      newName: '',
      currentClassId: this.$store.state.currentClassId
    }
  },
  computed: {
    getCurrentClassId () {
      return this.$store.state.currentClassId
    }
  },
  watch: {
    getCurrentClassId (val) {
      this.currentClassId = val
      this.getMess()
    }
  },
  mounted () {
    if (this.$store.getters.currentClass) {
      this.getMess()
    }
  },
  methods: {
    getMess () {
      const param = {
        access_token: this.access_token,
        classId: this.currentClassId
      }
      this.$http.post(requestUrl.getClassInfo, param).then((res) => {
        this.classInfo = res
        this.currentClassId = res.id
        this.creatQrCode(res.classNum)
        this.newName = this.classInfo.className
      })
    },
    editCancel() {
      this.newName = ''
      this.editVis = false
    },
    editFun () {
      if (this.classInfo.isDel) return
      this.editVis = true
      this.newName = this.classInfo.className
    },
    editOk() {
      if (this.newName === '') {
        this.$message.warning('请输入班级名称')
        return
      }
      if (this.newName.length > 16) {
        this.$message.warning('班级名称应在16个字以内')
        return
      }
      const param = {
        access_token: this.access_token,
        classId: this.currentClassId,
        name: this.newName
      }
      this.$http.post(requestUrl.updateClassName, param).then((res) => {
        if (res) {
          this.$message.success('修改名称成功')
          this.editVis = false
          const classList = this.$store.state.classList.map((c) => {
            if (c.id === this.currentClassId) c.className = this.newName
            return c
          })
          this.$store.commit('setClassList', classList)
          this.classInfo.className = this.newName
        }
      })
    },
    jsFun () {
      if (this.classInfo.isDel) return
      this.jsVis = true
    },
    jsCancel () {
      this.jsVis = false
    },
    jsOk () {
      const param = {
        access_token: this.access_token,
        classId: this.currentClassId
      }
      this.$http.post(requestUrl.dissolveClass, param).then((res) => {
        if (res) {
          const classList = this.$store.state.classList.filter(
            (c) => c.id !== this.currentClassId
          )
          this.$store.commit('setClassList', JSON.parse(JSON.stringify(classList)))
          Bus.$emit('groupIndex',0)
          this.$message.success('解散班级成功！')
          this.jsVis = false
          this.classInfo.isDel = true
          this.$forceUpdate()
        }
      })
    },
    creatQrCode (id) {
      if (this.qrcode) {
        this.qrcode.clear()
        this.qrcode.makeCode(id)
        return
      }
      this.qrcode = new QRCode(this.$refs.qrcode, {
        text: id, // 需要转换为二维码的内容
        width: 130,
        height: 130,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      })
    }
  }
}
</script>
